import { contextFactory } from '@frontend/design-system';
import type { UseSendFormsProvidersResults } from './hooks/useSendFormsProviders';

export const [SendFormsContext, useSendFormsContext] = contextFactory<UseSendFormsProvidersResults>();
